<template>
  <div v-if="isLoaded" class="wheel-prize"> 
    <div class="wheel-prize-canvas" :style="{ 
			'background-image': 'url(' + data.priceBgcImg + ')'
		 }" :class="{
      'is-five-prize': isFivePrize,
    }">
      <ul>
        <li class="prize" v-for="item in allPrize" :key="item.id">
          <span class="prize-text" v-html="item.prizeDesc"></span>
        </li>
      </ul>
      <div class="center-btn" ref="centerBtn">
        <div class="center-btn-bg" :style="{ 
					'background-image': 'url(' + data.priceBtnImg + ')'
				}" :class="aleardyInvoke && 'bg-effect'"></div>
        <p class="center-btn-arrow" :style="{ transform: `rotate(${rotation}deg)` }"></p>
      </div>
      <div class="center-btn-text" @click="start">
      </div>
    </div>

    <!-- 规则定位到页面右上角 -->
		<div class="pos-rule" @click="handleClickRule">规则</div>
		<!-- 规则弹窗 -->
		<div v-if="showRulePopup" class="pop-box">
			<div class="rule-pop-box">
				<div class="rule-content">
					<p class="rule-content-title">活动规则</p>
					<div class="rule-content-content"><p></p>{{ ruleContent }}</div>
					<div class="rule-close" @click="handleCloseClick">
						<div class="rule-close-content">我知道了</div>
					</div>
				</div>
			</div>
		</div>

    <!-- 蒙层 活动未开始/活动已结束/未命中抽奖名额 -->
    <div v-if="showInterceptPopup" class="pop-box">
			<div class="late-pop-box">
				<div class="late-title">{{ popupContent.title }}</div>
				<p class="late-title">{{ popupContent.subTitle }}</p>
				<div class="late-close" @click="handleCloseClick">返回</div>
			</div>
		</div>

    <!-- 中奖弹窗 -->
    <div v-if="showPrizePopup" class="pop-box">
			<div class="success-pop-box">
				<div class="success-content" :class="!awardUrl && 'success-content-no-btn'">
					<p class="success-content-title">恭喜您获得优惠券</p>
					<p class="success-content-content" v-html="awardTips"></p>
					<p v-if="awardUrl" class="success-content-btn" @click="jumpCouponPage()">马上借款 立享优惠</p>
					<p v-else class="success-content-tips">请前往APP“我的-优惠券”页面查看</p>
				</div>
				<div class="success-close" @click="handleClosePrizePopup"></div>
			</div>
    </div>
  </div>
</template>

<script>
import { post } from "../common/http";
import createMessage from './Toast/index.js';
import clientUtil from "../common/clientUtil";
import { getUrlParam, sensorsBuriedPoint, formatTimeStamp, isIOS } from '../common/util';

export default {
  name: "WheelPrize",
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      allPrize: [],
      rotation: 0,
      isSpinning: false,
      intervalId: null,
      ruleContent: '', // 规则文案
      isLoaded: false, // 页面是否可以渲染
      showRulePopup: false, // 展示规则弹窗
      showInterceptPopup: false, // 展示拦截弹窗
      showPrizePopup: false, // 展示中奖弹窗
			aleardyInvoke: false, // 是否已经触发抽奖
			prizeIDList: [],  // 关联奖品ID组成的清单
			popupContent: {}, // 蒙层文案
			awardTips: '', // 中奖文案
			awardUrl: '', // 中奖后跳转地址
			invokePeriod: 0, // 参与活动间隔
			activityNum: 0, // 抽奖次数
    }
  },
  computed: {
    isFivePrize() {
      return this.allPrize.length === 5;
    },
    isSixPrize() {
      return this.allPrize.length === 6;
    }
  },
  async mounted() {
    // 获取配置的奖品信息
    this.getWheelPrizeInfo();
		console.log('页面展示信息', this.data);
		// 活动频次检查 检查是否可抽奖
		const checkResult = await post("/api/v1/landingPage/frequencyCheck", { activityId: this.data.prizeDrawID });
		const { code, data } = checkResult;
		if (code !== 0) {
			createMessage({
				text: checkResult.desc,
				timeout: 2000
			});
			this.isSpinning = true;
			return;
		}
		if (!data.able) {
			this.interceptPopupShow(2, data.nextFrequencyTime);
		}
  },
  methods: {
    async getWheelPrizeInfo() {
      if (!this.data.prizeDrawID) {
        createMessage({
					text: '还没有奖品信息呢，稍后再试吧～',
					timeout: 2000
				});
        return;
      }
      try {
				const info = await post("/api/v1/landingPage/getWheelPrizeInfo", { activityId: this.data.prizeDrawID });
				console.log('活动配置信息', info);
				const { code, data } = info;
				if (code === 0) {
          const { activity = {}, prizeList = [] } = data;
          this.allPrize = prizeList;
          this.ruleContent = activity.activityDesc;
					console.log('当前时间戳', Date.now());
					if (Date.now() < activity.startTime) {
            // h5端展示活动未开始弹窗
						this.interceptPopupShow(0);
          } else if (Date.now() > activity.endTime) {
            // h5端展示活动已结束弹窗
						this.interceptPopupShow(1);
          }
					this.allPrize.map(item => {
						this.prizeIDList.push(item.coupon && item.coupon.couponTemplateId || '谢谢参与'); // 谢谢参与没有奖品ID
					})
					this.invokePeriod = activity.period;
					sensorsBuriedPoint("ActivityPageView", this.formatSensorData());
				}
			} catch (error) {
				console.log(error);
			}
      this.isLoaded = true;
    },
    async start() {
			this.aleardyInvoke = true;
      if (this.isSpinning) return;
			sensorsBuriedPoint("PrizeDrawClick", this.formatSensorData());
      this.isSpinning = true;
      // 先让指针快速转动
      this.intervalId = setInterval(() => {
        this.rotation += 40;
      }, 20);
      // 抽奖接口
			let result;
			try {
				result = await post("/api/v1/landingPage/invokeActivity", { activityId: this.data.prizeDrawID });
			} catch (error) {
				result = {}				
			}
			const { code, data } = result;
			if (code !== 0) {
				const failReason = result.desc || "系统异常，请稍后重试";
				if (code === 9997) {
					this.interceptPopupShow(0);
				} else if (code === 9998) {
					this.interceptPopupShow(1);
				} else {
					createMessage({
						text: failReason,
						timeout: 2000
					});
					// 抽奖按钮可再次点击
					this.isSpinning = false;
				}
				this.handlePageArrow();
				sensorsBuriedPoint("GrantAwardResult", this.formatSensorData({ IsSucess: 0, FailReason: failReason, PrizeID: [] }));
				return;
			};
			if (data.prizeId) {
				const randomPrizeIndex = this.allPrize.findIndex(item => item.id === result.data.prizeId);
				if (randomPrizeIndex === -1) { // 兼容处理：返回的奖品id不存在
					createMessage({
						text: '服务开小差了，稍后再试吧～',
						timeout: 2000
					});
					return;
				}
				this.activityNum++;
				const gotPrize = this.allPrize[randomPrizeIndex];
				if (data.prizeContent === 'COUPON') { // 抽中的是优惠券
					this.getCouponTemplateId = gotPrize.coupon.couponTemplateId;
				} else {
					this.getCouponTemplateId = '谢谢参与';
				}
				sensorsBuriedPoint("GrantAwardResult", this.formatSensorData({ IsSucess: 1, PrizeID: [ this.getCouponTemplateId ] }));
				const eachSectorAngle = 360 / this.allPrize.length;
				let targetRotation = 360 * 5 * this.activityNum + eachSectorAngle * randomPrizeIndex + eachSectorAngle / 2;
				// 确保目标角度大于当前旋转角度
				while (targetRotation < this.rotation) {
					targetRotation += 360;
				}
				clearInterval(this.intervalId);
				// 让指针平滑过渡到目标位置
				this.$nextTick(() => {
					this.rotation = targetRotation;
				});
				// 弹出中奖弹窗
				setTimeout(() => {
					if (data.prizeContent === 'NONE') { // 抽中的是谢谢参与,toast提示
						const toastText = this.invokePeriod ? `很遗憾，暂未中奖<br />请于${this.invokePeriod}天后再次参与抽奖` : '很遗憾，暂未中奖<br />请稍后重试';
						createMessage({
							text: toastText,
							timeout: 2000
						});
						// 抽奖按钮可再次点击
						this.isSpinning = false;
						return;
					}
					sensorsBuriedPoint("AwardHintPop", this.formatSensorData({ PrizeID: [ this.getCouponTemplateId ] }));
					this.awardTips = this.allPrize[randomPrizeIndex].awardWord;
					this.awardUrl = this.allPrize[randomPrizeIndex].awardUrl;
					this.showPrizePopup = true;
				}, 2500);
				return;
			}
			// 未中奖，根据错误原因做特定处理
			if (data.result === 'UNSATISFIED_CONDITION') {
				// 抽奖按钮可再次点击
				this.isSpinning = false;
				sensorsBuriedPoint("GrantAwardResult", this.formatSensorData({ IsSucess: 0, FailReason: '未满足抽奖条件', PrizeID: [] }));
				// 未满足抽奖条件，跳转微信小程序
				const pageUrl = isIOS() ? 
					'hfqdl://alert/alert?finish_myself=1&action=%255B%257B%2522title%2522%253A%2522%25E7%25A1%25AE%25E8%25AE%25A4%25E6%2589%2593%25E5%25BC%2580%25E5%25BE%25AE%25E4%25BF%25A1%25E5%25B0%258F%25E7%25A8%258B%25E5%25BA%258F%25EF%25BC%259F%2522%252C%2522subtitle%2522%253A%2522%2522%252C%2522cancel%2522%253A%2522%25E5%258F%2596%25E6%25B6%2588%2522%252C%2522sure%2522%253A%2522%25E7%25A1%25AE%25E5%25AE%259A%2522%252C%2522scheme%2522%253A%2522hfqdl%253A%252F%252Fwechat%252Fapplet%253FuserName%253Dgh_a0b8ebbaa29c%2526path%253D%252Fpages%252Fsplash%252Findex%2522%252C%2522textAlignment%2522%253A%2522center%2522%257D%255D&isDecode=1&from=wheelPrize' :
					'hfqdl://alert/alert?finish_myself=1&action=%5B%7B%22title%22%3A%22%E7%A1%AE%E8%AE%A4%E6%89%93%E5%BC%80%E5%BE%AE%E4%BF%A1%E5%B0%8F%E7%A8%8B%E5%BA%8F%EF%BC%9F%22%2C%22subtitle%22%3A%22%22%2C%22cancel%22%3A%22%E5%8F%96%E6%B6%88%22%2C%22sure%22%3A%22%E7%A1%AE%E5%AE%9A%22%2C%22scheme%22%3A%22hfqdl%3A%2F%2Fwechat%2Fapplet%3FuserName%3Dgh_a0b8ebbaa29c%26path%3D%2Fpages%2Fsplash%2Findex%22%2C%22textAlignment%22%3A%22center%22%7D%5D';
				clientUtil.openNewWebPage({
					pageUrl,
				})
			} else if (data.result === 'UNSATISFIED_FREQUENCY') {
				this.interceptPopupShow(2, data.nextFrequencyTime);
			}
			this.handlePageArrow();
    },
		interceptPopupShow(index, timestamp) {
			let time;
			time = timestamp ? formatTimeStamp(timestamp) : '下次';
			const pupupTips = [
				{
					title: '活动暂未开始',
					subTitle: '敬请期待'
				}, {
					title: '活动已结束',
					subTitle: '更多精彩活动请持续关注好分期'
				}, {
					title: '暂不符合抽奖条件',
					subTitle: `请${time}再来参与抽奖`
				}
			]
			this.popupContent = pupupTips[index];
			this.showInterceptPopup = true;
		},
		handlePageArrow() {
			// 指针指向12点
			this.rotation = Math.ceil(this.rotation / 360) * 360;
			clearInterval(this.intervalId);
		},
		jumpCouponPage() {
			sensorsBuriedPoint("UseAwardClick", this.formatSensorData({ PrizeID: [ this.getCouponTemplateId ] }));
			clientUtil.openNewWebPage({
				pageUrl: this.awardUrl
			});
			this.handleClosePrizePopup();
		},
    // 展示规则弹窗
		handleClickRule() {
			this.showRulePopup = true;
			this.stop();
		},
    // 点击关闭当前页面
		handleCloseClick() {
			this.move();
			if (this.showRulePopup) {
				// 关闭规则弹窗
				this.showRulePopup = false;
				return;
			}
			clientUtil.closePage();
		},
		handleClosePrizePopup() {
			this.showPrizePopup = false;
			// 抽奖按钮可再次点击
			this.isSpinning = false;
		},
    prevent(e) {
      e.preventDefault();
    },
    /** *滑动限制** */
    stop() {
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', this.prevent, false); // 禁止页面滑动
    },
    /** *取消滑动限制** */
    move() {
      document.body.style.overflow = ''; // 出现滚动条
      document.removeEventListener('touchmove', this.prevent, false);
    },
		// 埋点公共属性
		formatSensorData(data) {
      return {
				ActivityPageID: sessionStorage.getItem("pageId") || 0,
        ActivityPageName: sessionStorage.getItem("pageName") || "",
        Source: getUrlParam("from") || "",
				PrizeID: this.prizeIDList,
				...data
			}
    },
  },
  beforeDestroy() {
    this.move();
  }
}
</script>

<style lang="less" scoped>
.wheel-prize {
  text-align: center;
	overflow: hidden;

  &-canvas {
    position: relative;
    width: 100%;
    height: 324px;
    background-size: 100% 100%;
    padding: 30px;

    .prize {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      transform-origin: center;
    }

    .prize-text {
      transform: translateY(-100px) rotate(0deg);
      font-size: 19px;
      font-weight: bold;
      font-family: DINPro-Medium, DINPro;
      color: #680000;
      :deep(span) {
        font-family: DINPro-Medium, DINPro;
        color: #FF0000;
				font-weight: bold;
      }
    }

    .prize:nth-child(1) {
      transform: rotate(30deg);
			.prize-text {
        color: #FFFFFF;
      }
    }

    .prize:nth-child(2) {
      transform: rotate(90deg);
    }

    .prize:nth-child(3) {
      transform: rotate(150deg);
    }

    .prize:nth-child(4) {
      transform: rotate(210deg);
    }

    .prize:nth-child(5) {
      transform: rotate(270deg);
    }

    .prize:nth-child(6) {
      transform: rotate(330deg);
    }

    .center-btn {
      position: absolute;
      z-index: 2;
      top: 114px;
      left: 133px;
      width: 110px;
      height: 110px;
      will-change: transform;
      transition: transform 3s ease-out;
      /* 触发硬件加速 */
      transform: translateZ(0);

      &-bg {
        width: 108px;
        height: 112px;
        background-size: 100% 100%;
				animation: openAnimLinear 600ms linear infinite alternate-reverse;
      }
			.bg-effect {
				animation: none;
      }

      &-arrow {
        position: absolute;
        z-index: -1;
        top: -23px;
        left: 40px;
        width: 30px;
        height: 72px;
        background-image: url('https://datahub.haohuan.com/gfs/2025-05/ae130ed2d6040201149d139a3b826ba3.png');
        background-size: 100% 100%;
        transform-origin: bottom center;
        transition: transform 1s ease-out;
      }
    }

    .center-btn-text {
      position: absolute;
      z-index: 2;
      top: 120px;
      left: 123px;
      width: 84px;
      height: 84px;

    }
  }

  .is-five-prize {
    .prize:nth-child(1) {
      transform: rotate(36deg);
    }

    .prize:nth-child(2) {
      transform: rotate(108deg);
    }

    .prize:nth-child(3) {
      transform: rotate(180deg);
    }

    .prize:nth-child(4) {
      transform: rotate(252deg);
    }

    .prize:nth-child(5) {
      transform: rotate(324deg);
    }
  }
}

.pos-rule {
	position: absolute;
	top: 45px;
	right: 0;
	width: 50px;
	height: 23px;
	background: rgba(255,255,255,0.37);
	border-radius: 100px 0px 0px 100px;
	border: 1px solid #FFFFFF;
	line-height: 23px;
	font-size: 13px;
	font-family: PingFang SC;
	color: #690000;
}
.pop-box {
	position: fixed;
	z-index: 3;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.8);
	min-height: 100vh;
	.late-pop-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		height: 100%;
		.late-title {
			font-size: 24px;
			color: #FFFFFF;
			line-height: 38px;
			font-weight: bold;
			font-family: DINPro-Medium;
		}
		.late-close {
			width: 60px;
			height: 28px;
			line-height: 28px;
			border: 1px solid #ffffff;
			border-radius: 14px;
			font-size: 14px;
			font-family: PingFang SC;
			color: #ffffff;
			margin-top: 27px;
		}
	}
	.rule-pop-box {
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		position: relative;
		height: 100%;
		.rule-content {
			box-sizing: border-box;
			width: 305px;
			background: #ffffff;
			border-radius: 12px;
			padding: 20px;
			&-title {
				font-size: 16px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #2E2E33;
				margin-bottom: 6px;
			}
			&-content {
				min-height: 24px;
				max-height: 235px;
				font-size: 13px;
				line-height: 24px;
				font-family: DINPro-Regular, DINPro;
				color: #6d6d75;
				text-align: left;
				overflow: scroll;
				-webkit-overflow-scrolling: touch;
				white-space: pre-line; // 识别\n进行换行
				&::-webkit-scrollbar {
					display: none;
				}
			}
			.rule-close {
				padding-top: 20px;
				&-content {
					height: 46px;
					line-height: 46px;
					background: #FF3838;
					border-radius: 23px;
					font-weight: bold;
					font-size: 16px;
					color: #FFFFFF;
					text-align: center;
				}
			}
		}
	}
	.success-pop-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		height: 100%;
		.success-content {
			width: 295px;
			height: 293px;
			background: url("https://datahub.haohuan.com/gfs/2025-05/519d36ed309510c25ed0cf13f5c0c26c.png");
			background-size: 100% 100%;
			padding-top: 31px;
			&-title {
				font-size: 25px;
				font-family: Alibaba PuHuiTi;
				font-weight: bold;
				color: #ffffff;
				text-shadow: 0px 4px 2px rgba(156, 9, 0, 0.11);
				height: 24px;
				line-height: 24px;
			}
			&-content {
				margin-left: 18px;
				margin-top: 24px;
				width: 260px;
				height: 69px;
				background: #FFF2E7;
				box-shadow: 0px 4px 2px 0px rgba(156, 9, 0, 0.11);
				border-radius: 8px;
				line-height: 69px;
				font-size: 16px;
				font-family: DINPro-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				/deep/ span {
					color: #ff4f2f;
					font-size: 17px;
					font-family: DINPro-Medium, DINPro;
					font-weight: 500;
				}
			}
			&-btn {
				margin-left: 17px;
				margin-top: 55px;
				width: 261px;
				height: 50px;
				line-height: 50px;
				background: linear-gradient(0deg, #F3CB74, #FFEDCE);
				box-shadow: 0px 6px 6px 0px rgba(156, 9, 0, 0.23);
				border-radius: 25px;
				font-size: 19px;
				font-family: Alibaba PuHuiTi;
				font-weight: 500;
				color: #9e4f18;
			}
			&-tips {
				font-size: 12px;
				color: #FFFFFF;
				line-height: 17px;
				margin-top: 19px;
			}
		}
		.success-content-no-btn {
			width: 295px;
			height: 234px;
			background: url("https://datahub.haohuan.com/gfs/2025-05/d89ef49992751bb6a3e720803b692d8f.png");
			background-size: 100% 100%;
		}
		.success-close {
			margin-top: 27px;
			width: 21px;
			height: 21px;
			background: url("https://datahub.haohuan.com/gfs/2023-01/b7e348f9563dc0d5b86f173ad1aca198-8.png");
			background-size: 21px 21px;
		}
	}
}
@keyframes openAnimLinear {
  0%{
    transform: scale(0.96);
  }
  100%{
    transform: scale(1.04);
  }
}
</style>